var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    enableBackground: "new 0 0 18 21",
    height: 21,
    viewBox: "0 0 100 100",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Money_Back_Guarantee",
    d: "m98 50c0 26.467-21.533 48-48 48s-48-21.533-48-48c0-1.657 1.342-3 3-3s3 1.343 3 3c0 23.159 18.841 42 42 42s42-18.841 42-42-18.841-42-42-42c-11.161 0-21.526 4.339-29.322 12h11.322c1.658 0 3 1.343 3 3s-1.342 3-3 3h-18c-1.658 0-3-1.343-3-3v-18c0-1.657 1.342-3 3-3s3 1.343 3 3v10.233c8.851-8.448 20.481-13.233 33-13.233 26.467 0 48 21.533 48 48zm-45-3h-6c-1.655 0-3-1.346-3-3s1.345-3 3-3h12c1.658 0 3-1.343 3-3s-1.342-3-3-3h-6v-3c0-1.657-1.342-3-3-3s-3 1.343-3 3v3c-4.963 0-9 4.037-9 9s4.037 9 9 9h6c1.655 0 3 1.346 3 3s-1.345 3-3 3h-12c-1.658 0-3 1.343-3 3s1.342 3 3 3h6v3c0 1.657 1.342 3 3 3s3-1.343 3-3v-3c4.963 0 9-4.037 9-9s-4.037-9-9-9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPrimary);
export default __webpack_public_path__ + "static/media/payment_primary.fedb236fc1f31e3de8bcc47607671955.svg";
export { ForwardRef as ReactComponent };